import React, {useContext} from 'react';
import Message from '../../components/message/Message';
import {Link} from 'react-router-dom';
import {generateRoutePath} from 'epic-ue-locale-mode';
import {HttpContext} from '../../../server/utils/httpContext';

/**
 * 500 component.  Shown when page not found.
 */
const Error500 = function Error500() {
    const context = useContext(HttpContext);
    if (context) {
        context.status = 500;
    }

    return (
        <div id="errorpage">
            <div className="error-box">
                <div>
                    <h1>500</h1>
                    <h2>
                        <Message code="epic.error.500.title1" />
                        <Message code="epic.error.500.title2" />
                    </h2>
                    <h3>
                        <Message code="epic.error.500.msg1" />
                    </h3>
                    <p>
                        <Message code="epic.error.500.msg2" />
                    </p>
                    <Link to={generateRoutePath('/')} className="cta-button text-center">
                        <Message code="epic.error.404.home" />
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Error500;
